import { createSettingsParams, SettingsParamType } from '@wix/tpa-settings';
import {
  enumSettingsParam,
  textSettingsParam,
  AccessibilityHtmlTags,
} from '../WixServices/settingsParamsUtils';
import { BorderStyle } from '../WixServices/types';

// Page-specific form settings params type
export type IPageSettingsParams = {
  pageTitleText: SettingsParamType.Text;
  pageTitleTagName: SettingsParamType.String;
  fieldsBorderStyle: BorderStyle;
  formHeading1HtmlTag: SettingsParamType.String;
  formHeading2HtmlTag: SettingsParamType.String;
  formTextHtmlTag: SettingsParamType.String;
  formFieldsLabelsHtmlTag: SettingsParamType.String;
  formFieldsInputTextHtmlTag: SettingsParamType.String;
};

// Page-specific form settings params definitions
export const pageSettingsParamsDefinitions = {
  pageTitleText: textSettingsParam('wix-services.page_title_text'),
  pageTitleTagName: enumSettingsParam(AccessibilityHtmlTags.MainHeading),
  fieldsBorderStyle: enumSettingsParam(BorderStyle.BOX),
  formHeading1HtmlTag: enumSettingsParam(
    AccessibilityHtmlTags.SecondaryHeading,
  ),
  formHeading2HtmlTag: enumSettingsParam(
    AccessibilityHtmlTags.SecondaryHeading,
  ),
  formTextHtmlTag: enumSettingsParam(AccessibilityHtmlTags.Paragraph),
  formFieldsLabelsHtmlTag: enumSettingsParam(AccessibilityHtmlTags.Paragraph),
  formFieldsInputTextHtmlTag: enumSettingsParam(
    AccessibilityHtmlTags.Paragraph,
  ),
};

// Create page-specific params (like bookings-calendar-widget pattern)
const pageSettingsParams = createSettingsParams<IPageSettingsParams>(
  pageSettingsParamsDefinitions,
);

export default pageSettingsParams;
